/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Draftemail_Alreadysent3Inputs */

const en_coinvestments_draftemail_alreadysent3 = /** @type {(inputs: Coinvestments_Draftemail_Alreadysent3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An email was already sent to this investor. You're composing a new one.`)
};

/**
* | output |
* | --- |
* | "An email was already sent to this investor. You're composing a new one." |
*
* @param {Coinvestments_Draftemail_Alreadysent3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_draftemail_alreadysent3 = /** @type {((inputs?: Coinvestments_Draftemail_Alreadysent3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Draftemail_Alreadysent3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_draftemail_alreadysent3(inputs)
});
export { coinvestments_draftemail_alreadysent3 as "coInvestments_draftEmail_alreadySent" }